import Exim from 'exim';
import { observable } from 'mobx';
import lazy from './lazy-loader';

const LicenseObservable = observable({
  license: new Map()
});

const LicenceAPI = {
  loadAll() {
    return lazy.item('/api/license');
  }
};

const Store = Exim.createStore({
  actions: ['load', 'logout'],
  initial: {
    licence: {}
  },

  logout() {
    this.reset();
    LicenseObservable.license.clear();
    return lazy.clear();
  },

  load(force = false) {
    if (!!force) {
      lazy.clear();
    }
    this.set({ loadingLicence: true });
    return LicenceAPI.loadAll().then((res) => {
      if (!res) return;
      let { license } = res.body.result;
      if (!!license) {
        LicenseObservable.license.replace(license);
        this.set({
          licence: license,
          loadingLicence: false
        });
      }
    });
  }
});

Store.LicenseObservable = LicenseObservable;
export default Store;
export { LicenseObservable };
